module.exports = __webpack_public_path__ + "img/AccountingDonutInvoiced.fa7dbad4.png";